<template>
<div>
    <v-row>
       <v-col lg="4" md="3" cols="12" class="text-center align-self-center">
      <v-divider style="border-width:1px;border-color:#2e368f"></v-divider>
    </v-col>

    <v-col lg="4" md="6" cols="12" class="text-center align-self-center">
      <h2 id="title" class="display-2 flex-grow-1" style="font-family:'Tajawal', sans-serif !important">{{title}}</h2>
    </v-col>

    <v-col lg="4" md="3" cols="12" class="text-center align-self-center">
      <v-divider style="border-width:1px;border-color:#2e368f"></v-divider>
    </v-col>

    </v-row>

 <carousel dir="ltr"  class="mt-4 w-100" paginationColor="#D6D6D6" paginationActiveColor="#869791" :perPageCustom="[[0,1],[575, 2],[1100, 3],[1250, 4]]">
       <slide v-for="(item,idx) in items" :key="idx" ><v-img @click="toProducts(item)" style="margin:auto" max-height="100" max-width="150" :src="baseURL + item.image"></v-img></slide>

  </carousel>
</div>
</template>

<script> 
import { Carousel, Slide } from "vue-carousel";

export default {
    props: {
        title: String,
        items: Array        
    },
    computed:{
        baseURL: {
            get() {return localStorage.getItem('country') == 'TZ' ? 'https://tz.time-zone.store' : 'https://time-zone.store/'}
        }
    },
    components: {
          Carousel,
        Slide
    },
    watch:{
        items(val){
        }
    },
    data: () => ({
        showTitle: false,
          
        categories: [{
                img: "https://www.worldofwatches.com/media/wysiwyg/homepageicons-sunglasses.jpg"
            },
            {
                img: "https://www.worldofwatches.com/media/wysiwyg/homepageicons-watches.jpg"
            },
            {
                img: "https://www.worldofwatches.com/media/wysiwyg/homepageicons-handbags.jpg"
            },
            {
                img: "https://www.worldofwatches.com/media/wysiwyg/homepageicons-beauty.jpg"
            },
            {
                img: "https://www.worldofwatches.com/media/catalog/product/cache/9df2eec62a290f757942cbd6dcc3d91d/m/e/mens-erika-color-mix-rb4171-60155-54.jpg"
            }
        ]
    }),
    methods: {
        toProducts(item){
            localStorage.setItem('filterId' , 12);
            localStorage.setItem('brandFilter' , item.name);
            localStorage.setItem('filterValue', item.id)
            localStorage.setItem('categoryId', 1)

            var counrty = localStorage.getItem('country') == 'TZ' ? 'Tanzania' : 'Sudan';
            this.$router.push({path: `/products/WATCHES`}); //${counrty}
        }
    },
};
</script>

<style lang="scss" scoped>
@media (min-width: 1264px) {
    .lg5-custom {
        width: 20% !important;
        max-width: 20% !important;
        flex-basis: 20% !important;
    }
}

#header {
    font-size: 44px;
}

 .left-border{
    text-align:left;
     border-left: 8px solid #2e368f;
 }
 .right-border{
     text-align: right;
     border-right: 8px solid #2e368f;
 }
 

 
.v-card {
    transition: opacity 0.4s ease-in-out;
}

.v-card:not(.on-hover) {
    opacity: 0.9;
}

#category-card::before {
    opacity: 1;
    background: hsla(50, 0%, 0%, 0.6);
    transition: 0.3s opacity ease-out;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

#category-title::before,
#category-title::after {
    content: "";
    width: 0;
    height: 2px;
    position: absolute;
    transition: all 0.2s linear;
    background: #fff;
}

span::before,
span::after {
    content: "";
    width: 2px;
    height: 0;
    position: absolute;
    transition: all 0.2s linear;
    background: #fff;
}

#category-title::before,
#category-title::after {
    width: 100%;
}

#category-title::before,
#category-title::after {
    transition-delay: 0.2s;
}

#category-title span::before,
#category-title span::after {
    transition-delay: 0s;
}

#category-title::before {
    right: 0;
    top: 0;
}

#category-title::after {
    left: 0;
    bottom: 0;
}

#category-title span::before {
    left: 0;
    top: 0;
}

#category-title span::after {
    right: 0;
    bottom: 0;
}

#category-card:hover #category-title::before,
#category-card:hover #category-title::after {
    transition-delay: 0s;
}

#category-card:hover #category-title span::before,
#category-card:hover #category-title span::after {
    transition-delay: 0.2s;
}

#category-card:hover #category-title span::before,
#category-card:hover #category-title span::after {
    height: 100%;
}

#category-title {
    cursor: pointer;
    color: white;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
}

.on-hover::before {
    content: "";
    position: absolute;
    opacity: 0;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    transition: 0.3s opacity ease-in;
    // background: linear-gradient(0deg, rgba(82, 82, 61, 0.609) 0%, rgba(169, 172, 172, 0.459) 100%);
}
</style>
